import { BusRoute, Trip } from "../model/busRoute";
import Pin from "./Pin";
import {
    getDepartureTimeAsDayjs,
    getArrivalTimeAsDayjs,
    getStartDepotDepartureTime,
    getEndDepotArrivalTime,
    formatDateTime,
    formatTime
} from "../libs/routes-lib";
import React, { useCallback, useEffect, useState } from "react";
import { useScroll } from "../libs/hooksLib";
import { Button, Tooltip, Timeline, Typography } from "antd";
import { useAppContext } from "../libs/contextLib";
import config from "../config";
import { cloneDeep, debounce, last } from "lodash";
import RouteNumber from "./RouteNumber";
import { find } from "lodash/collection";
import { CommentOutlined, EyeOutlined } from "@ant-design/icons";
import { differenceBy } from "lodash/array";
import ChatButton from "./ChatButton";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import dayjs from "../dayjs";
import useAllVehicleTypes from "../hooks/useAllVehicleType";
import { Col } from "react-bootstrap";
import { Bus } from "./Icons";

const { Title, Text } = Typography;

export default function SimpleStopTimesTimetable({
    route,
    charter,
    allStops,
    trip,
    setRoute,
    setFocusStop,
    setSelectedStop,
    selectedStop,
    setUpdated,
    immutable = false,
    operator,
}) {
    const location = useLocation();
    const [editing, setEditing] = useState(false);
    const [executeScroll, scrollRef] = useScroll();
    const [stopTimes, setStopTimes] = useState([]);
    const { allVehicleTypes } = useAllVehicleTypes();

    useEffect(() => {
        executeScroll();
    }, [selectedStop, executeScroll]);

    useEffect(() => {
        if (!trip?.stopTimes) return
        console.log('trip updated... setting stopTimes', trip.stopTimes)
        // setStopTimes(immutable ? trip.getVisiblePublicStopTimes(allStops) : trip.stopTimes)
        setStopTimes(trip.stopTimes)
    }, [trip, allStops, immutable]);

    return (
        <div className='timeline-container'>
            {allVehicleTypes && <div className="icon-info-text">
                <Bus />
                <div className="w-100">
                {trip.vehicleTypes && trip.vehicleTypes.length > 0
                    ? trip.vehicleTypes.map(id => {
                    const quantity = trip.vehicleTypeQuantities?.[id] || 1;
                    return (
                        <span key={id}>{allVehicleTypes[id]?.vehicleTypeName} (<strong>{quantity}</strong>)</span>
                    );
                    }).reduce((prev, curr, i) => [prev, ', ', curr])
                    : "Vehicle type not selected"}
                </div>
            </div>}
            <Timeline>
                {route.startDepot &&
                    <Timeline.Item key={`route-startdepot`} 
                        dot={<Pin size={20} type={allStops[route.startDepot.stopId]?.stopType} sequence={"S"} />}>
                        <div className="timeline-item" key={`StopTime-Row-${route.startDepot.stopId}}`}
                            style={{ cursor: 'pointer' }}
                            onMouseOver={() => {
                                if (!editing) {
                                    setFocusStop({ ...route.startDepot, ...allStops[route.startDepot.stopId] });
                                }
                            }}
                            onClick={() => {
                                setSelectedStop({ ...route.startDepot, ...allStops[route.startDepot.stopId] });
                            }}>
                            <div className="timeline-content">
                                <Text strong>Start at depot</Text>
                                <Text type="secondary">{allStops[route.startDepot.stopId]?.stopName}</Text>
                                {charter && route.startDepotDuration > 0 && (
                                    <Text type="secondary">
                                        {formatDateTime(getStartDepotDepartureTime(route, stopTimes[0], charter))}
                                    </Text>
                                )}
                            </div>
                        </div>
                    </Timeline.Item>
                }
                {
                    stopTimes && stopTimes.map((stop, idx) => {
                        const isInRostering = /rostering|charters|shiftbats/.test(location?.pathname);
                        const showSuburb = operator?.opts?.rosterable?.showSuburbNextToStop && isInRostering
                        const suburb = showSuburb && allStops[stop.stopId]?.suburb ? `, ${allStops[stop.stopId]?.suburb}` : ''
                        return (<>
                            <Timeline.Item key={`StopTime-TRow-${stop.stopTimeId}}`} 
                                dot={<Pin size={20} type={allStops[stop.stopId]?.stopType} sequence={idx + 1} />}>
                                <div className="timeline-item" key={`StopTime-Row-${stop.stopTimeId}}`}
                                    style={{ cursor: 'pointer' }}
                                    onMouseOver={() => {
                                        if (!editing) {
                                            setFocusStop({ ...stop, ...allStops[stop.stopId] });
                                        }
                                    }}
                                    onClick={() => {
                                        setSelectedStop({ ...stop, ...allStops[stop.stopId] });
                                    }}>
                                    <div className="timeline-content">
                                        {(() => {
                                            // first stop is always pickup only. if no charterStopType its a dropoff only. last stop is always dropoff only.
                                            const charterStopType = stop.charterStopType || (idx === 0 ? 'pickup' : 'dropoff');
                                            const typeLabel = charterStopType === 'both' ? 'Drop-off & Pick-up' : 
                                                             charterStopType === 'pickup' ? 'Pick-up' : 'Drop-off';
                                            
                                            return (
                                                <>
                                                    <Text strong>Stop {idx + 1} - {typeLabel}</Text>
                                                    <Text type="secondary">{allStops[stop.stopId]?.stopName}{suburb}</Text>
                                                    
                                                    {stop.timingPoint || route.charter || operator?.opts?.timetable?.stopTimes?.showAll ? (
                                                        <div>
                                                            {charterStopType === 'pickup' && (
                                                                <>
                                                                    <div>Pickup - <Text type="secondary">{getDepartureTimeAsDayjs(trip, stop).format('HH:mm')}</Text></div>
                                                                    <div>Est. arrival - <Text type="secondary">{getArrivalTimeAsDayjs(trip, stop).format('HH:mm')}</Text></div>
                                                                </>
                                                            )}
                                                            {charterStopType === 'dropoff' && (
                                                                <>
                                                                    <div>Dropoff - <Text type="secondary">{getArrivalTimeAsDayjs(trip, stop).format('HH:mm')}</Text></div>
                                                                </>
                                                            )}
                                                            {charterStopType === 'both' && (
                                                                <>
                                                                    <div>Dropoff - <Text type="secondary">{getArrivalTimeAsDayjs(trip, stop).format('HH:mm')}</Text></div>
                                                                    <div>Pickup - <Text type="secondary">{getDepartureTimeAsDayjs(trip, stop).format('HH:mm')}</Text></div>
                                                                </>
                                                            )}
                                                            {stop.notes && stop.notes.trim() && (
                                                                <div style={{ marginTop: '4px' }}>
                                                                    <Text type="secondary" style={{ fontStyle: 'italic' }}>
                                                                        Notes: {stop.notes}
                                                                    </Text>
                                                                </div>
                                                            )}
                                                        </div>
                                                    ) : <></>}
                                                </>
                                            );
                                        })()}

                                    </div>
                                </div>
                            </Timeline.Item>
                        </>
                        )
                    })
                }
                {route.endDepot &&
                    <Timeline.Item key={`route-endDepot`}
                        dot={<Pin size={20} type={allStops[route.endDepot.stopId]?.stopType} sequence={"E"} />}>
                        <div className="timeline-item" key={`StopTime-Row-${route.endDepot.stopId}}`}
                            style={{ cursor: 'pointer' }}
                            onMouseOver={() => {
                                if (!editing) {
                                    setFocusStop({ ...route.endDepot, ...allStops[route.endDepot.stopId] });
                                }
                            }}
                            onClick={() => {
                                setSelectedStop({ ...route.endDepot, ...allStops[route.endDepot.stopId] });
                            }}>
                            <div className="timeline-content">
                                <Text strong>End at depot</Text>
                                <Text type="secondary">{allStops[route.endDepot.stopId]?.stopName}</Text>
                                {charter && route.endDepotDuration > 0 && (
                                    <Text type="secondary">
                                        {formatTime(getEndDepotArrivalTime(route, last(stopTimes), charter))}
                                    </Text>
                                )}
                            </div>
                        </div>
                    </Timeline.Item>
                }
            </Timeline>
        </div>
    );
}
